import { render, staticRenderFns } from "./KhList.vue?vue&type=template&id=77f70b90&scoped=true&"
import script from "./KhList.vue?vue&type=script&lang=js&"
export * from "./KhList.vue?vue&type=script&lang=js&"
import style0 from "./KhList.vue?vue&type=style&index=0&id=77f70b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f70b90",
  null
  
)

export default component.exports